<div class="appbased-tv__footer">
  <span [innerHTML]="'global.footer' | translate"></span>
</div>